const COVER_STORY = [
  { value: 'Magazine subscription', text: 'Magazine subscription' },
  { value: 'Library books', text: 'Library books' },
  { value: 'Other', text: 'Other…' }
];

type COVER_STORY = typeof COVER_STORY;

export default COVER_STORY;
